<div class="d-flex flex-column">
  <lead-details-title
    [from]="flightItineraries[0].departureAirport.cityName"
    [to]="flightItineraries[0].finalDestinationAirport.cityName"
    textSize="small"
  />

  <lead-details-subtitle
    [departDate]="flightItineraries[0].departureAt | date: 'EEE, MMM d'"
    class="mt-1"
  />
</div>

<logos-container [flightItineraries]="flightItineraries" />
